export const HEALTH_ROUTE = "/health";

// markets token & prices routes
export const GET_TOKEN_LIST_ROUTE = "/tokens";
export const GET_WHIRLPOOL_POSITIONS_ROUTE = "/user/whirlpools";
export const GET_WHIRLPOOL_ROUTE = "/whirlpools";
export const FETCH_ORACLE_PRICES_ROUTE = "/prices";
//markets token & prices routes  - wallet header required

// markets loans routes
export const GET_LOANS_WITH_INFO_ROUTE = "/loans/info";

// markets lending vaults routes
export const ROUTE_GET_LENDING_VAULTS = "/lending_vaults/info";
export const ROUTE_GET_LENDING_VAULTS_HISTORY = "/lending_vaults/history";
export const ROUTE_GET_LENDING_VAULTS_UPDATE_HISTORY = "/lending_vaults/update_history";
export const ROUTE_GET_LENDING_VAULT_ALLOCATIONS = "/lending_vaults/allocation";
// markets lending vaults routes - wallet header required
export const ROUTE_GET_LENDING_USER_VAULT_POSITIONS = "/lending_vaults/user_positions";
export const ROUTE_GET_USER_LENDING_VAULTS_ACTIVE_STATS = "/lending_vaults/user_positions/active_stats";
export const ROUTE_GET_USER_POSITION_DEPOSIT_SUMMARY = "/lending_vaults/deposit_summary";
export const ROUTE_GET_USER_EXTERNAL_REWARDS_PNL = "/lending_vaults/pnl/rewards";
export const ROUTE_GET_USER_GENESIS_ACCESS = "/user/genesis";

//markets routes
export const GET_MARKET_STATS_ROUTE = "/stats";
export const GET_MARKET_BORROW_CAPS_ROUTE = "/borrow_caps";
export const ROUTE_REFRESH_MARKET_TVL_STATS = "/tvl/refresh";
export const ROUTE_UPDATE_USD_PRICE_MAPPINGS = "/usd-price-mappings"; //TODO: Not implemented in the FE
//markets routes - wallet header required
export const GET_PORTFOLIO_STATS_ROUTE = "/portfolio/stats";
export const ROUTE_PORTFOLIO_REWARDS = "/portfolio/rewards";

//markets rates routes
export const GET_RATE_HISTROY_UPDATE = "/rates/update"; //TODO: Not implemented in the FE
export const GET_RATE_HISTORY_ROUTE = "/rates/history";
export const ROUTE_GET_LOOP_VAULTS_HISTORY = "/loop/history";

//market quote routes
export const MARKET_QUOTE_ROUTE = "/quote";
export const MARKET_QUOTE_FOR_APY_ROUTE = "/quote/apy";
export const ROUTE_GET_REFINANCE_INFO = "/quote/refinance";
export const ROUTE_INCREASE_CREDIT_QUOTE = "/quote/increase_credit";
export const ROUTE_LOAN_SALE_QUOTE = "/quote/sell";
//market quote routes - wallet header required
export const GET_BEST_LOOP_QUOTE_ROUTE = "/quote/loop";
export const GET_MAX_QUOTE_ROUTE = "/quote/max";
export const GET_BEST_QUOTE_ROUTE = "/quote/best";

//advanced lending routes
export const GET_STRATEGY_INFO_ROUTE = "/strategy/infos";
export const GET_MIN_PRINCIPAL_ROUTE = "/strategy/min_principal";

// market loop routes
export const GET_LOOP_VAULTS_INFO_ROUTE = "/loop/info";
export const ROUTE_GET_LATEST_COLLATERAL_YIELD_PCT = "/loop/collateral_yield/latest";
export const ROUTE_GET_LATEST_COLLATERAL_YIELD_PCTS = "/loop/collateral_yield/latest/mints";

export const POST_COLLATERAL_YIELDS_IN_RANGE_ROUTE = "/loop/collateral_yield/range";
export const ROUTE_UPDATE_COLLATERAL_YIELD_UPDATE = "/loop/collateral_yield/update";
//market loop routes - wallet header required
export const GET_USER_LOOP_INFO_ROUTE = "/loop/user_positions";
export const GET_LOOP_POSITION_STATS_ROUTE = "/loop/position_stats";

//oracle routes
export const ROUTE_FETCH_MARKET_INFORMATIONS = "/oracles/data/market_informations";
export const ROUT_FETCH_ORACLE_HISTORICAL_PRICES_ROUTE = "/oracles/prices/history";

// market external yield routes
export const ROUTE_GET_EXTERNAL_YIELD_INFO = "/external_yield/info";

// ruby routes
export const ROUTE_GET_POINTS = "/points/rewards";
export const ROUTE_GET_USER_WL_INFO = "/points/user/wl"; //TODO: Not implemented in the FE
// ruby routes - wallet header required
export const ROUTE_GET_USER_REFERRAL_INFO_ROUTE = "/user/referral_info";
export const ROUTE_REFER_USER = "/user/refer";
export const ROUTE_GET_POINTS_USER = "/points/user"; //TODO: Not implemented in the FE
export const ROUTE_GET_USER_POINTS_CALC = "/points/user/calc";
export const ROUTE_GET_USER_REFERRAL_POINTS_CALC = "/points/user/referrals";
export const ROUTE_GET_USER_TOTAL_BY_TYPE = "/points/user_total_by_type";

//Ruby external routes - wallet header required
export const ROUTE_VERIFY_TWITTER_FOLLOW = "/twitter/verify_follow";
export const ROUTE_FETCH_TWITTER_REQUEST_TOKEN = "/twitter/request_token";
export const ROUTE_FETCH_TWITTER_OAUTH_TOKEN = "/twitter/oauth_token";
export const ROUTE_FETCH_TWITTER_INFO = "/twitter/info";
export const ROUTE_VERIFY_DISCORD = "/discord/verify";
export const ROUTE_FETCH_DISCORD = "/discord";
export const ROUTE_ONBOARDING = "/onboarding";

// transaction status route
export const TRANSACTIONS_STATUS_ROUTE = "/txns/status";

// Pandora transaction routes - Routes for handling complex multi-transaction operations
// that require orchestration of multiple instructions, some using proprietary packages. Used for loop unwind instructions, all require wallet header.

// pandora meteora routes
export const METEORA_BASE = "/meteora";
export const ROUTE_METEORA_DEPOSIT_QUOTE = `${METEORA_BASE}/deposit_quote`;
export const ROUTE_METEORA_WITHDRAW_QUOTE = `${METEORA_BASE}/withdraw_quote`;

// pandora loop ixs routes
export const LOOP_BASE = "/loop";
export const ROUTE_LOOP_WIND_QUOTE_IXS = `${LOOP_BASE}/quote/wind`;
export const ROUTE_LOOP_UNWIND_QUOTE_IXS = `${LOOP_BASE}/quote/unwind`;
export const ROUTE_LOOP_ROLLOVER_QUOTE_IXS = `${LOOP_BASE}/quote/rollover`;
